/** CSS class names driving the roster action-icon requirement badge (see compliance-item-evidence.component.scss badge styles). */
export enum IconRequirementBadge {
    NONE = 'badge-none',
    REQUIRED_UNFULFILLED = 'badge-required',
    REQUIRED_FULFILLED = 'badge-complete'
}
